var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cliente-right-tab"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }